import { Popover } from '@nextui-org/react';
import styled from 'styled-components';

import { ChevronRightIcon } from '../../assets';
import zIndexLayers from '../../services/ZIndexLayers/ZIndexLayers';
import { ThemeProp } from '../../theme/Themes';

export const FilterContent = styled.div`
  width: 100%;
  height: 100%;
  max-width: 13.75rem;
  background: ${({ theme }: ThemeProp) => theme.colors.layout.surface.default};

  @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.minMobile}) {
    width: 17rem;
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    max-width: unset;
  }
  background: ${({ theme }: ThemeProp) => theme.colors.layout.surface.default};
`;

export const FilterComponentContainer = styled.div`
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    border-bottom: none;
  }
`;

export const FilterActionButtonsContainer = styled.div`
  z-index: ${zIndexLayers.elevateOne};
  display: flex;
  background: transparent;
  margin: 0.5rem 1rem 1rem 1rem;
  gap: 0.5rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    gap: 1rem;
    margin: 0;
    padding: 1.5rem;
    border-top: solid 1px ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  }
`;

export const FilterContentContainer = styled.div`
  position: fixed;
  top: 3.125rem;
  z-index: ${zIndexLayers.popup};
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
`;

export const StyledChevronRightIcon = styled(ChevronRightIcon).attrs((props) => {
  return {
    color: props.theme.colors.greyscale.c050,
  };
})``;

export const StyledPopoverContent = styled(Popover.Content)`
  background: ${({ theme }: ThemeProp) => theme.colors.layout.surface.default};
  border: 1px solid ${({ theme }: ThemeProp) => theme.colors.neutrals.c100};
  box-shadow: ${(props: ThemeProp) => props.theme.shadows.menu};
  border-radius: 0.5rem;
`;
